import { IonDatetime } from '@ionic/react'
import React from 'react'
import PushServiceItem from '../PushServiceItem'

interface PushServiceTimeProps {
    time: string
    onChangeTime: (s: string) => void
}

const PushServiceTime: React.FC<PushServiceTimeProps> = (props) => {
    return (
        <PushServiceItem>
            <p className='pushServiceNameTitle'>推送时间</p>
            <span className='pushServiceNameSubTitle'>
                机器人将从下面的时间开始的时候逐一推送
            </span>
            <div className='newsBotSetTime'>
                <IonDatetime
                    placeholder={`${props.time}` || '选择时间'}
                    cancelText='取消'
                    doneText='确定'
                    displayFormat='HH:mm'
                    onIonChange={(e) => props.onChangeTime(e.detail.value!)}
                />
            </div>
        </PushServiceItem>
    )
}

export default PushServiceTime
